export function getDefaultRequestedAmount(
  minAmount: number,
  maxAmount: number,
  amountStep: number
) {
  if (amountStep <= 0 || maxAmount <= minAmount) {
    return minAmount;
  }

  const midpointAmount = minAmount + (maxAmount - minAmount) * 0.5;
  const steppedOffset = Math.round((midpointAmount - minAmount) / amountStep) * amountStep;

  return Math.min(minAmount + steppedOffset, maxAmount);
}
